<template>
  <PageContentLayoutOnly>
    <ModernTable
      :filters="filters"
      :rows="apAttachments"
      :columns="columns"
      :pagination="pagination"
    >
      <template v-slot:header>
        <div class="pb-5">
          <b-button @click="createAttachmentModal()" size="is-small" type="is-primary" rounded>
            Add Attachment
          </b-button>
          <b-button
            type="is-ghost"
            @click="toggleFilters"
            :style="styles.filterButton"
            :class="'filter-button ' + (filters.show ? 'active' : '')"
          >
            <b-icon pack="mdi" icon="filter-outline" size="is-small" style="display: inline-block">
            </b-icon>
            <div style="display: inline-block">Filter</div>
          </b-button>
        </div>
      </template>
    </ModernTable>

    <Modal :toggle.sync="toggle">
      <template v-slot:header>Invoice Attachment</template>

      <InvoiceAttachmentModal
        :apInvoiceID="parseInt(apInvoiceID)"
        :attachment="selectedApInvoiceAttachment"
      />
    </Modal>
  </PageContentLayoutOnly>
</template>

<script>
import { mapState } from 'vuex'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import ModernTable from '@/components/tables/Modern/Table'
import Modal from '@/components/Modal'
import InvoiceAttachmentModal from '@/components/Modals/DocumentInvoiceAttachmentModal'
import { methods } from './keys/methods'
import { data } from './keys/data'

export default {
  name: 'InvoiceCharges',
  components: {
    PageContentLayoutOnly,
    ModernTable,
    Modal,
    InvoiceAttachmentModal
  },

  data,
  methods,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId
    })
  },

  watch: {
    hoaId() {
      this.reload()
    },
    async toggle() {
      if (this.toggle == false) {
        await this.reload()
        this.toggle = false
        if (this.Modal && this.Modal != undefined) {
          this.Modal.$emit('update:toggle', (this.toggle = false))
        }
      }
    }
  },

  async mounted() {
    this.apInvoiceID = this.$route.params.id || 0
    await this.reload()
  },

  i18n: {
    messages: {
      en: { invoiceAttachments: { title: 'Attachments' } }
    }
  }
}
</script>

<style></style>
